module.exports = __webpack_public_path__ + "img/Bell.2ab47b78.svg";